import React from 'react';
import { Annotation } from '@/pages/upload-document/components/annotation/annotation';
import { annotationToPageBox } from '@/pages/upload-document/components/annotation/annotation-geometry';
import type { Size } from '@/components/pdf-viewer';
import styles from './annotation-preview.module.css';
import { SIGNER_OPTION_COLORS } from '@/pages/upload-document/document-annotator/utils';

type AnnotationPreviewProps = {
	annotation: Annotation;
	index: number;
	/** Size of the page overlay the preview is placed on, in base px. */
	pageSize: Size;
};

export const AnnotationPreview = (props: AnnotationPreviewProps) => {
	const annotationColors = {
		background: SIGNER_OPTION_COLORS[1] + '50',
		border: SIGNER_OPTION_COLORS[1] + 'FF',
	};
	const box = annotationToPageBox(props.annotation, props.pageSize);

	return (
		<div
			className={styles['annotation-preview']}
			data-annotation-id={props.annotation.id}
			style={{
				borderColor: annotationColors.border,
				backgroundColor: annotationColors.background,
				left: box.x,
				top: box.y,
				width: box.width,
				height: box.height,
			}}
		>
			<span style={{ color: annotationColors.border }}>
				{props.index + 1}
			</span>
		</div>
	);
};
